import {Fonts} from "@/constants/font"; import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext"; import {NewsPanel} from "@/scenes.ui/news-panel"; import {Tr} from "@/i18n/i18n"; import CU from "@/utils/c-u"; import CardStore from "@/store/card"; import {CreatureUtils} from "@/utils/creature-utils"; import {WarriorClass} from "@/store/level/types";

export class EvolutionLink extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, x: number, y: number, linkText: string, color: string = '#D0D0D0', isLongManual: boolean = false) {
        super(scene);

        this.scene = scene;
        this.x = x * CU.S;
        this.y = y * CU.S;

        let link = new BBCodeText(scene, 0, 0, `[color=${color}][shadow][u]${linkText}[/u][/shadow][/color]`, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '12pt',
            shadow: { offsetX: -1, offsetY: 2, color: '#000000' },
            stroke: '#000000',
            align: 'center',
            wrap: { mode: 1, width: 420 },
            underline: { color: color, thickness: 1, offset: 4 }
        }).setScale(CU.S, CU.S);

        link.setOrigin(0.5);
        link.setInteractive().on('pointerup', () => {
            CardStore.fetchEvolutionInfo()
                .then(evo => {
                    const localizedClasses = evo.availableClasses
                        .map((wClass: WarriorClass) => CreatureUtils.getClassName(wClass))
                        .filter(className => className && className.trim() !== "")
                        .join(', ');

                    let evolutionText = "";
                    if (localizedClasses) {
                        evolutionText += `${Tr('evolution_description')} \n\n ${localizedClasses}.`;
                        evolutionText += `\n\n\n ${evo.comment}.`;
                    }

                    if (evolutionText.trim() !== "") {
                        let ip: NewsPanel = new NewsPanel(scene, canvas, Tr('manual'), evolutionText, () => { ip.close(); }, false, isLongManual);
                        ip.openAnimated();
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        });

        if (link.text.trim() !== "") {
            this.add(link);
        }
    }
}
